var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMobileNativeapp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.063 0H3.936c-.984 0-1.75.793-1.75 1.75v10.5c0 .984.766 1.75 1.75 1.75h6.126c.957 0 1.75-.766 1.75-1.75V1.75c0-.957-.793-1.75-1.75-1.75zM7 13.125a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875zM10.063 1.75v8.75H3.936V1.75h6.126z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileNativeapp);
export default __webpack_public_path__ + "static/media/icon_mobile_native app.604b98b7e9055308e39f47b99a42209e.svg";
export { ForwardRef as ReactComponent };